import { CONTACT_US_EMAIL } from '@app/common/src/constants'
import { Link as DecoratedLink, Typography } from '@dtx-company/design-system/src'
import { FC } from 'react'
import { createMailToLink } from '@dtx-company/true-common/src/utils/createMailToLink'

export const SubscriptionErrorMessage: FC = () => {
  return (
    <div>
      <Typography
        data-testid={'subscription-error-message'}
        color={'error'}
      >{`Sorry, an error occurred. Please refresh the page and `}</Typography>
      <DecoratedLink
        href={createMailToLink(CONTACT_US_EMAIL, {
          subject: 'Update Page Error',
          body: `I am having trouble paying for a Flowcode account. Can you help me?`
        })}
      >
        CONTACT US
      </DecoratedLink>
      <Typography color={'error'}>{` if the problem persists.`}</Typography>
    </div>
  )
}
